    <!--EL FORMGROUP QUE SE COLOCA ACA DEBE SER EL MISMO QUE ESTA DEFINIDO EN EL COMPONENT-->
<form [formGroup]="archivoSeparador" >
  <div class="container-fluid">
    <div class="row">
      <div id="pnlInformativo">
        <div class="dvGral">
          <span class="lblTituloPnl">Importar Documento</span>
        </div>
      </div>
    </div>
    <div class="row pnlGroupingGralRow">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-3">
            <div style="display:inline;" class="dvValidador">
              <span>(*)</span>
            </div>
            <div style="display:inline;">
              <span>Tipo Documento</span>
            </div>
          </div>
          <div class="col-md-9">
            <select id="tipoDocumento" name="Tipo Documento" formControlName="tmpIdTipoDocumento" [value]="0" style="width:98%">
              <option value="0" disabled selected>Seleccione</option>
              <option [value]="tipoDoc.ctdcIdTipoDocumento" *ngFor="let tipoDoc of lstTipodoc | async">{{tipoDoc.ctdcNombre}}</option>
            </select>
            <div style="color:darkred" *ngIf="archivoSeparador.controls['tmpIdTipoDocumento'].errors">
              Debe ingresar Tipo Documento
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            &nbsp;
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div style="display:inline;" class="dvValidador">
              <span>(*)</span>
            </div>
            <div style="display:inline;">
              <span>Seleccione el archivo</span>
            </div>
          </div>
          <div class="col-md-9">
            <input #fileUpload type="file" id="fuArchivo" name="archivo" formControlName="tmpArchivo"/>
            <div style="color:darkred" *ngIf="archivoSeparador.controls['tmpArchivo'].errors">
              Debe seleccionar un archivo
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div style="float:right">
              <input type="button" class="btn btn-primary" (click)="CancelarImportacion()" value="Cancelar" />
              <input type="button" [disabled]="!(archivoSeparador.valid && NoClick)" class="btn btn-primary" value="Importar" (click)="this.disabled = true; ImportarArchivo($event);" />
            </div>
          </div>
        </div>
        <div style="margin:1em" *ngIf="archivoSeparador.valid==false">
          <div class="alert alert-danger">Por favor verifique que se hayan ingresado todos los campos</div>
        </div>
      </div>
      </div>
  </div>
</form>
